export default "__VITE_ASSET__a25de68b__"